import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// Styling: issueListControls.css, which the extension (styles/bem.css) and Team Review (review-app/index.tsx) load.
// Keep this React module safe for the server's native Node imports too.
/** The label for clearing every filter, shared with the empty state (IssueListEmptyState.tsx). */
export const CLEAR_FILTERS_LABEL = 'Clear filters';
/**
 * The line under an issue list when filters hide issues: "{n} issue(s) hidden by filters. Clear filters" (Emily,
 * 2026-10-30, prototype docs/prototypes/quieter-issue-lists). It replaces the "N finished issues hidden" note; the
 * finished issues themselves are one choice away in Filter's Status presets. Nothing renders when filters hide nothing.
 * `oq-auto-review-ui` carries the token scope Team Review needs outside its list (styles.css).
 */
export function IssueListFilterNote({ count, onClear }) {
    if (count <= 0)
        return null;
    return (_jsxs("p", { className: "oq-auto-review-ui oq-issue-filter-note", children: [_jsxs("span", { children: [count, " ", count === 1 ? 'issue' : 'issues', " hidden by filters."] }), ' ', _jsx("button", { type: "button", className: "oq-issue-filter-note__clear", onClick: onClear, children: CLEAR_FILTERS_LABEL })] }));
}
//# sourceMappingURL=IssueListFilterNote.js.map